import { ChildSettlementDetails } from 'components/templates/settlement/ChildSettlementDetails/ChildSettlementDetails';

export const ChildSettlementPage = () => <ChildSettlementDetails />;
